import { isInteger } from './utils';

export default function currencyFormatter(value) {
  const absoluteValue = Math.abs(value);

  let scale = '';
  let scaledValue;
  let decimals;

  if (absoluteValue >= 1000000000000) {
    scale = 'T';
    scaledValue = absoluteValue / 1000000000000;
    decimals = 1;
  } else if (absoluteValue >= 1000000000) {
    scale = 'B';
    scaledValue = absoluteValue / 1000000000;
    decimals = 1;
  } else if (absoluteValue >= 1000000) {
    scale = 'M';
    scaledValue = absoluteValue / 1000000;
    decimals = 1;
  } else if (absoluteValue >= 1000) {
    scale = 'K';
    scaledValue = absoluteValue / 1000;
    decimals = 1;
  } else {
    scale = '';
    scaledValue = absoluteValue;
    decimals = 2;
  }

  const finalValue = isInteger(scaledValue)
    ? scaledValue
    : scaledValue.toFixed(decimals);

  if (isNaN(finalValue)) {
    return null;
  }

  const sign = value < 0 ? '-' : '';

  return `${sign}$${finalValue}${scale}`;
}
